import { userMutations } from "./users/mutations";
import { generalMutations } from "./general/mutations";
import { invoiceProjectMutations } from "./invoice-projects/mutations";
import { bookingSettingsMutations } from "./booking/mutations";
import { accountingSettingsMutations } from "./accounting/mutations";
import { billingSettingsMutations } from "./billing/mutations";
import { labelSettingsMutations } from "./label/mutations";
import { custom_textsSettingsMutations } from "./custom_texts/mutations";
import { noticesSettingsMutations } from "./notices/mutations";
import { languageSettingsMutations } from "./language/mutations";
import { sharingMutations } from "./sharing/mutations";
import { promotionSettingsMutations } from "./promotion/mutations"
import { externalUserMutations } from "./externalusers/mutations";
import { taskSettingsMutations } from "./task/mutations";
import * as types from './types';
export const mutations = {
  ...userMutations,
  ...generalMutations,
  ...invoiceProjectMutations,
  ...bookingSettingsMutations,
  ...accountingSettingsMutations,
  ...billingSettingsMutations,
  ...labelSettingsMutations,
  ...custom_textsSettingsMutations,
  ...noticesSettingsMutations,
  ...languageSettingsMutations,
  ...sharingMutations,
  ...promotionSettingsMutations,
  ...externalUserMutations,
  ...taskSettingsMutations,
  [types.TaskSettingsData.SET.ALL] (state, payload) {
    console.log("PPPPPPPPPPPP",payload)
    //const { settingsKey } = payload
    if(!payload.data)
      state['taskSettingsData'] = payload;
    else
     state['taskSettingsData'] = payload.data;
  }
}